'use strict';

import $ from 'jquery';
import productReviews from './product-reviews';

export default function(API) {
	$(document).ready(() => {

		API.log('INIT Product');

		if( $('.product-carousel').length ){

			import('./product-carousel').then(({ productCarousel: carousel }) => {
				carousel('.product-carousel');
				console.log('IMPORT carousel');
			});

		}

		productReviews();

		// Init product cards
		const products = $('.v4-product-card');

		import('./product-page').then(({ default: productPage }) => {
			productPage(products);
			console.log('IMPORT product page');
		});

		if ($('.form-leasing').length) {
			import('./leasing').then(({ default: leasing }) => {
				leasing();
			});
		}

	});
}
